import AspectMenu from "@/components/search/AspectMenu";
import ShareIcon from "@mui/icons-material/Share";
import { ShareItemModel, ShareList } from "./ShareList";
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";
import PillButton from "@/app/shared/PillButton";

export function ShareButton({ item }: { item: ShareItemModel }) {
  return (
    <AspectMenu
      label="Share"
      icon={<ShareIcon />}
      target={
        <PillButton
          sx={{
            gridRow: "span 2",
            gridColumn: 3,
            backgroundColor: "grey.100",
          }}
          startIcon={<ShareIcon />}
        >
          Share
        </PillButton>
      }
      body={() => <ShareList item={item} />}
      onOpen={() => {
        CreateAnalyticEvent({
          event: {
            adIds: [item.id],
            eventType: "ITEM#ENGAGEMENT#SHARE#OPEN",
          },
        });
      }}
    />
  );
}
